export default "__VITE_PUBLIC_ASSET__93f4cb84__"